﻿$.fn.dxCtrlContentEmailBase64 = function custom_dxCtrlContentEmailBase64(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentemailbase64 dx-ctrl");
        this.createInstance(new cdxCtrlContentEmailBase64(this, option));
    }
    return this;
}

window.cdxCtrlContentEmailBase64 = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivDoc = null
    var dxContentEmailBase = null;
    var jauge = null;
    var $TableMenu = null
    function mConstruit() {
        container.empty()
        container.css("padding", "0 25px 25px 25px")
        container.css("position", "relative")

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow();


        $TableMenu = $("<table style=''/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($TableMenu)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var $Td1 = $("<td style='width:1px;'/>").appendTo($Tr)
        var $Td2 = $("<td style='width:1px;'/>").appendTo($Tr)

        //var dxBtImportInEmail = $("<div style=''/>").appendTo($Td1).dxCtrlCmdImportExportFile({
        //    bddCtrl:option.bddCtrl,
        //    extension: ".emlz",
        //    titleExport: "Sauvegarder dans la box",
        //    onValideImport: function (lstPathName) {
        //        $("<div/>").appendTo(container).dxCtrlCmdImportInEmail({
        //            bddCtrl: option.bddCtrl,
        //            lstPathName: lstPathName,
        //            container: container,
        //            onGetData: function () { return dxContentEmailBase.mGetData() },
        //            onImport: function (data, changeObjet, viderFichier, ajouterFichier, remplacerToutHtml, funcFin) {
        //                if (changeObjet) dxContentEmailBase.mChangeObjet(data.objet)
        //                if (viderFichier) dxContentEmailBase.mClearFiles()
        //                if (ajouterFichier) dxContentEmailBase.mAddFiles(data.lstfile)
        //                jauge.mShow()
        //                dxContentEmailBase.mChangeHtml(data.html, data.htmlSansBody, remplacerToutHtml, function () {
        //                    funcFin()
        //                    jauge.mHide()
        //                })
        //            }
        //        })
        //    },
        //    //onExport: function (pathNameFile) {
        //    //    if (dxContentEmailBase.isDirty()) {
        //    //        dxContentEmailBase.mSave(function () { mExport() })
        //    //    } else { mExport() }
        //    //    function mExport() {
        //    //        dxContentEmailBase.mExportBox(pathNameFile, function () {
        //    //            mNotify("Le fichier a été sauvegardé dans votre box", "success", 2000)
        //    //        })
        //    //    }
        //    //}
        //    mGetPathNomFichier: function (funcOk) {
        //        if (dxContentEmailBase.isDirty()) {
        //            dxContentEmailBase.mSave(function () { mFinalise() })
        //        } else { mFinalise() }
        //        function mFinalise() {
        //            var objet = option.data.objet
        //            if (typeof objet == "undefined" || objet == null || objet.length == 0) objet = "Nouveau document email"
        //            objet = objet.remplacerTout(" ", "_")
        //            objet = objet.remplacerTout(carInterditFichier, "")
        //            if (objet.length > 50) objet = objet.substring(0, 50)
        //            objet += ".emlz"
        //            funcOk(option.bddCtrl.repertoireBrouillon + "/" + objet)
        //        }
        //    },
        //    containerExported: container.closest(".dx-popup-normal"),
        //    exportObligeSaisieNomFichier: false,
        //    exeExport: function (pathNomFichier, funcOk) {
        //        dxContentEmailBase.mExportBox(pathNomFichier, function () { funcOk() })
        //    },
        //    onExported: function (newPathNomFichier) {
        //        mNotify("Votre document a été sauvegardé dans votre box", "success", 6000)
        //        //var popupPage = page.mGetPopupPage(option.data)
        //        //if (popupPage != null) popupPage.mDestroy()
        //        ////$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
        //        //option.bddCtrl.getObjet({ id_fichier: newPathNomFichier }).mShowPopup()
        //    }
        //}).dxCtrlCmdImportExportFile("instance")

        if (typeof option.data64Default != 'undefined') {
            $("<div style=''/>").appendTo($Td2).dxCtrlButton({
                icon: "fas fa-eraser",
                txtTooltip: "Recharger le modèle par défaut<br/><span style='font-size:90%;'><i>(Rechargera votre modèle<br/>avec celui qui était initialement configuré dans l'application)</i>",
                //width: HeightButton,
                //height: HeightButton,
                onClick: function (e) {
                    option.data64 = option.data64Default
                    mRempliDoc()
                    mNotify("Vous avez rechargé le modèle avec le modèle par défaut.", "success", 6000)
                }
            });
        }

        $DivDoc = $("<div style='width:100%;height:calc(100% - " + $TableMenu.innerHeight() + "px);'/>").appendTo(container)
        mRempliDoc()
    }

    function mRempliDoc() {
        $DivDoc.empty()
        dxContentEmailBase = $("<div style='width:100%;height:100%;'/>").appendTo($DivDoc).dxCtrlContentEmailBase({
            bddCtrl: option.bddCtrl,
            readOnly: false,
            data64: option.data64,
            notAllowLoadConcepteur: false,
            loadConcepteurInHtml:true,
            saveAuto: false,
            showObjetFile: option.showObjetFile,
            hideAddFile: option.hideAddFile,
            showObjet: option.showObjet,
            onContentReady: function () {
                jauge.mHide()
            }
        }).dxCtrlContentEmailBase("instance")
    }

    this.mStopSaveAuto = function (funcFin) {
        dxContentEmailBase.mSaveAuto(function (base64string) {
            funcFin(base64string)
        }, true)
    }

    this.element = function () { return container }

    mConstruit();
}